import { render, staticRenderFns } from "./ManoeuvreRatingDanish.vue?vue&type=template&id=4ffa04f5"
import script from "./ManoeuvreRatingDanish.vue?vue&type=script&lang=js"
export * from "./ManoeuvreRatingDanish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports